import { render, staticRenderFns } from "./MusicVideos.vue?vue&type=template&id=920cb9b4"
import script from "./MusicVideos.vue?vue&type=script&lang=js"
export * from "./MusicVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports